module.exports = __webpack_public_path__ + "static/media/vender.c5a0a341.png";